import React from 'react';
import { PricingPlanCycle } from '@atlassian/cssxp-ccp-types';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { useFeatureToggle } from '@css-xp/base';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { CATALOGUE_CONSTANTS, STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';
import { fetchNativeProductCatalogueWithOfferingAndPricingPlans } from './queries/sxp-queries/fetch-native-catalogue-with-offering-pricing-plans';

export const useFetchNativeProductsForCatalogue = () => {
  const [isEnabled] = useFeatureToggle();
  const sxpClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.SXP), []);
  return usePersistedCacheQuery(fetchNativeProductCatalogueWithOfferingAndPricingPlans, {
    variables: {
      pageParams: {
        size: CATALOGUE_CONSTANTS.DEFAULT_ROWS_PER_PAGE_FOR_CATALOGUE,
      },
      pricingPlanFilterOptions: [
        {
          key: 'currency',
          value: 'USD',
        },
        {
          key: 'billingFrequency',
          value: PricingPlanCycle.MONTHLY,
        },
      ],
      filterOptions: [
        {
          key: 'includeProperties',
          values: ['vendorName'],
        },
      ],
      includeExperimentalProducts: isEnabled(STATSIG_FEATURE_GATES.ENABLE_EXPERIMENTAL_PRODUCTS_IN_CATALOG),
      isAddOnsSearchEnabled: isEnabled(STATSIG_FEATURE_GATES.ENABLE_ADD_ONS_PHASE_V2),
      isStatuspageEnabled: isEnabled(STATSIG_FEATURE_GATES.ENABLE_STATUSPAGE),
      isTeamWorkCollectionEnabled: isEnabled(STATSIG_FEATURE_GATES.ENABLE_TWC_SUPPORT_PHASE_1),
      isStrategyCollectionEnabled: isEnabled(STATSIG_FEATURE_GATES.ENABLE_STRATEGY_COLLECTION),
      isBitbucketProductEnabled: isEnabled(STATSIG_FEATURE_GATES.ENABLE_BITBUCKET),
    },
    nextFetchPolicy: 'cache-first',
    client: sxpClient,
  });
};
